import classNames from 'classnames';
import { func } from 'prop-types';
import React, { useState, useRef } from 'react';

import { useComponentSize } from '../../utils';
import Loader from '../Loader';

import s from './index.module.css';


const cx = classNames.bind(s);

const Image = ({ src, onSelect }) => {
  const [isLoading, setIsLoading] = useState(true);
  const wrapper = useRef();
  const { height } = useComponentSize(wrapper);

  return (
    <div className={s.imageWrapper} style={{ height: `${height > 0 ? height : 172}px` }}>
      <img
       ref={wrapper}
        onClick={onSelect}
        className={cx(s.image, { [s.image_loading]: isLoading })}
        src={src}
        alt=''
        onLoad={() => setIsLoading(false)}
      />
      {isLoading && <Loader />}
    </div>
  );
};

Image.propTypes = {
  onSelect: func
};

Image.defaultProps = {
  onSelect: () => {}
};

export default Image;
